<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('直播间名称')" prop="liveName">
                  <a-input v-model="queryParam.liveName" :maxLength="32" :placeholder="$t('请输入')+$t('直播间名称')" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('直播用户昵称')" prop="nickName">
                  <a-input v-model="queryParam.nickName" :maxLength="32" :placeholder="$t('请输入')+$t('直播用户昵称')" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('直播分类')" prop="categoryId">
                  <a-select style="width: 100%" v-model="queryParam.categoryId" :placeholder="$t('请选择')+$t('直播分类')">
                    <a-select-option v-for="(item, index) in categoryList" :value="item.id" :key="index">
                      {{ item.categoryName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['community:communitylive:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['community:communitylive:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['community:communitylive:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" :category-list="categoryList" @ok="getList"/>
      <goods-form ref="goodsForm"/>
      <url-form ref="urlForm"  />

      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered">
        <template slot="thumb" slot-scope="text, record">
          <div>
            <img v-if="record.thumb" :src="record.thumb"  style="width:60px;height:62px;" @click="handleRecordPreview(record.thumb)" alt="none"/>
          </div>
        </template>
        <span slot="categoryName" slot-scope="text, record">
          {{getCategoryNameById(record.categoryId)}}
        </span>
        <span slot="status" slot-scope="text, record">
            <custom-dict-tag :options="customDict.LiveStatusEnum" :color="true" :color-array="['orange','green', 'red']" :value="record.status"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.urlForm.handleShare(record)" >
             <a-icon type="edit" />{{$t('推流地址')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['community:communitylive:edit']" />
          <a @click="$refs.goodsForm.handleUpdate(record, undefined)" v-hasPermi="['community:communitylive:edit']">
             <a-icon type="edit" />{{$t('商品')}}
          </a>
          <br/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['community:communitylive:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical"  v-if="record.status===1" />
          <a @click="handleOpen(record)" v-if="record.status===1" >
            <a-icon type="open" />{{$t('开播')}}
          </a>
           <a-divider type="vertical"  v-if="record.status===2" />
          <a @click="handleClose(record)" v-if="record.status===2" >
            <a-icon type="close" />{{$t('结束直播')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['community:communitylive:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['community:communitylive:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageCommunityLive,
  listCommunityLive,
  delCommunityLive,
  communityLiveStart,
  communityLiveEnd
} from '@/api/community/live'
import { listCommunityVideoCategory } from '@/api/community/videoCategory'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import GoodsForm from './modules/GoodsForm'
import UrlForm from './modules/UrlForm.vue'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CommunityLive',
  components: {
    CustomDictTag,
    CreateForm,
    GoodsForm,
    UrlForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      categoryList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        liveType: undefined,
        imGroupId: undefined,
        liveName: undefined,
        nickName: undefined,
        picture: undefined,
        theme: undefined,
        intro: undefined,
        openTime: undefined,
        closeTime: undefined,
        expiredTime: undefined,
        effective: undefined,
        duration: undefined,
        pushUrl: undefined,
        pullUrl: undefined,
        chatNum: undefined,
        status: undefined,
        cutInfo: undefined,
        isErrorClose: undefined,
        errorCloseTime: undefined,
        categoryId: undefined,
        liveAddress: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('直播间名称'),
          dataIndex: 'liveName',
          align: 'center'
        },
        {
          title: this.$t('直播用户昵称'),
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: this.$t('直播封面'),
          scopedSlots: {customRender: 'thumb'},
          dataIndex: 'thumb',
          align: 'center'
        },
        {
          title: this.$t('预计开播时间'),
          dataIndex: 'preOpenTime',
          align: 'center'
        },
        {
          title: this.$t('直播关闭时间'),
          dataIndex: 'closeTime',
          align: 'center'
        },
        {
          title: this.$t('直播状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('直播分类'),
          dataIndex: 'categoryId',
          scopedSlots: { customRender: 'categoryName' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getCategoryList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询直播列表 */
    getList () {
      this.loading = true
     pageCommunityLive(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    getCategoryList () {
      listCommunityVideoCategory({"type":2}).then(response => {
        this.categoryList = response.data
      })
    },
    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.categoryList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.categoryName
      } else {
        return "";
      }
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        liveType: undefined,
        imGroupId: undefined,
        liveName: undefined,
        nickName: undefined,
        picture: undefined,
        theme: undefined,
        intro: undefined,
        openTime: undefined,
        closeTime: undefined,
        expiredTime: undefined,
        effective: undefined,
        duration: undefined,
        pushUrl: undefined,
        pullUrl: undefined,
        chatNum: undefined,
        status: undefined,
        cutInfo: undefined,
        isErrorClose: undefined,
        errorCloseTime: undefined,
        categoryId: undefined,
        liveAddress: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleOpen (row) {
      var that = this
      this.$confirm({
        title: this.$t('确认开播?'),
        onOk () {
          return communityLiveStart(row.id)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('开播成功')
              that.$message.success(message,3)
            })
        },
        onCancel () {
          //取消清空删除ids列表
        }
      })
    },
    handleClose (row) {
      var that = this
      this.$confirm({
        title: this.$t('确认关播?'),
        onOk () {
          return communityLiveEnd(row.id)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('关播成功')
              that.$message.success(message,3)
            })
        },
        onCancel () {
          //取消清空删除ids列表
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delCommunityLive(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/community/live/export',
            that.queryParam
          , `直播_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
